// Factory: nested objects (client) must be new on every call, otherwise
// RESET_STATE restores an object that SET_CLIENT already mutated.
export const getInitialState = () => ({
  cups: '',
  client: getInitialClient(),
  supplyPoint: null,
  electricityContractId: '',
  offerStatus: '',
  installationStage: '',
  overwrittenCups: false,
  intervalId: null,
  consumptionUpdated: false,
  errorInConsumptionPolling: false,
})

export const getInitialClient = () => ({
  id: null,
  name: null,
  email: null,
  phoneNumber: null,
  // Temporary change: currentFee calculated with solar margin
  electricityProduct: {
    name: 'UN Precio Clásico',
    id: 'CL_1P_20TD',
  },
})

export default getInitialState
